// ./src/components/features/SavedPlaces/PlaceTypeBadge/PlaceTypeBadge.tsx
//
// Badge displaying a saved place type with icon and color.
// Follows TireSetStatusBadge pattern.

import React from "react";
import { Badge, BadgeProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { PLACE_TYPE_MAP } from "@/config/placeTypeOptions";
import { AppIcon } from "@/components/generic";

// ============================================
// Types
// ============================================

export interface PlaceTypeBadgeProps extends Omit<BadgeProps, "color" | "children"> {
  /** Place type value from the database */
  value: string | null | undefined;

  /** Whether to show the icon */
  showIcon?: boolean;
}

// ============================================
// Component
// ============================================

export const PlaceTypeBadge: React.FC<PlaceTypeBadgeProps> = ({
  value,
  showIcon = true,
  size = "sm",
  variant = "light",
  ...rest
}) => {
  const { t } = useTranslation(["savedPlaces"]);

  const option = value ? PLACE_TYPE_MAP[value] : undefined;

  if (!option) return null;

  return (
    <Badge
      color={option.color}
      variant={variant}
      size={size}
      leftSection={
        showIcon ? <AppIcon iconName={option.icon} size={12} /> : undefined
      }
      {...rest}
    >
      {t(`savedPlaces:${option.labelKey}`)}
    </Badge>
  );
};